import { render, staticRenderFns } from "./ServiceMasterRegisterCompletePage.vue?vue&type=template&id=5913e339&"
import script from "./ServiceMasterRegisterCompletePage.vue?vue&type=script&lang=ts&"
export * from "./ServiceMasterRegisterCompletePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports